export const SPECIAL_CODES_COLLECTION = "settings";
export const SPECIAL_CODES_DOC_ID = "specialCodes";

export const CHECKOUT_MODES = [
  { text: "Subscription", value: "subscription" },
  { text: "One-time payment", value: "payment" },
];

/** Seed entry for the Pro-10 90-day offer (admin fills in the redeem code). */
export function defaultPro10SpecialCode() {
  return {
    code: "",
    enabled: true,
    name: "Everhost Pro - 10 guidebooks for 90 days",
    priceId: "price_1U1Qqv03NFhO4KkKVgw52JHe",
    productId: "prod_V1Tosmz6ee3VMJ",
    itemId: "PRO10-90",
    subscriptionType: "PRO10-90",
    subscriptionCount: 10,
    durationDays: 90,
    checkoutMode: "subscription",
    note: "",
  };
}

export function emptySpecialCode() {
  return {
    code: "",
    enabled: true,
    name: "",
    priceId: "",
    productId: "",
    itemId: "",
    subscriptionType: "",
    subscriptionCount: 10,
    durationDays: 90,
    checkoutMode: "subscription",
    note: "",
  };
}

export function normalizeSpecialCode(raw = {}) {
  const count = Number(raw.subscriptionCount);
  const days = Number(raw.durationDays);
  const mode =
    raw.checkoutMode === "payment" ? "payment" : "subscription";
  return {
    code: String(raw.code || "").trim(),
    enabled: raw.enabled !== false,
    name: String(raw.name || "").trim(),
    priceId: String(raw.priceId || "").trim(),
    productId: String(raw.productId || "").trim(),
    itemId: String(raw.itemId || "").trim(),
    subscriptionType: String(raw.subscriptionType || "").trim(),
    subscriptionCount: Number.isFinite(count) && count > 0 ? count : 10,
    durationDays: Number.isFinite(days) && days > 0 ? days : 90,
    checkoutMode: mode,
    note: String(raw.note || "").trim(),
  };
}

export function validateSpecialCodes(list) {
  if (!Array.isArray(list)) {
    return "Special codes must be a list.";
  }
  const seen = new Set();
  for (let i = 0; i < list.length; i++) {
    const entry = normalizeSpecialCode(list[i]);
    const label = `Code #${i + 1}`;
    if (!entry.code) {
      return `${label}: code is required.`;
    }
    const key = entry.code.toLowerCase();
    if (seen.has(key)) {
      return `Duplicate code "${entry.code}".`;
    }
    seen.add(key);
    if (!entry.name) {
      return `${label}: display name is required.`;
    }
    if (!entry.priceId) {
      return `${label}: Stripe price ID is required.`;
    }
    if (!entry.itemId) {
      return `${label}: item ID is required.`;
    }
    if (!entry.subscriptionType) {
      return `${label}: subscription type is required.`;
    }
  }
  return null;
}
